import IconSvg from './assets/icons/48/internal.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="intenal warning" src={IconSvg} width="48px" height="48px" />;

export default Icon;
